import React from 'react'
import "../Styles/Dev.css"
import VenueCard from '../Components/VenueCard'
import Modal from '../Components/Modal'
import RecognizeSong from '../Components/RecognizeSong'
import SubMenu from '../Components/SubMenu/HamburgerMenu'
import Header from '../Components/Header'

export default function Dev() {
  return (
    <div className="dev-wrapper">
{/*       <Modal /> */}
{/* <Header />
<SubMenu /> */}
    </div>
  )
}
